import { GaugeSVGBase } from "./GaugeSVGBase";
export default GaugeSVGBase;
